import * as Localization from "expo-localization";
import { I18n } from "i18n-js";
import AsyncStorage from "../components/AsyncStorage";

import en from "../locale/en";
import zh from "../locale/zh";
import jp from "../locale/jp";

const translations = {
  en: en,
  zh: zh,
  jp: jp
};

const i18n = new I18n(translations);

AsyncStorage.getData("lang").then((value) => {
  i18n.locale = value || "jp";
  // console.log("Localization.locale : ", Localization.locale);
  // if (!value) {
  //   i18n.locale = Localization.locale;
  // } else {
  //   // console.log(value);
  //   i18n.locale = value;
  // }
});

i18n.enableFallback = true;

export default i18n;
